import HttpFactory from "~/repository/factory";
import { ENDPOINTS } from "~/repository/endpoints";
import type {
  LessonIssueReportInput,
  LessonIssueReportReceipt,
} from "~/types/lessonIssueReports";

export function buildLessonIssueReportForm(
  input: LessonIssueReportInput,
): FormData {
  const form = new FormData();
  form.set("client_request_id", input.client_request_id);
  form.set("lesson_id", String(input.lesson_id));
  if (input.teaching_class_id != null) {
    form.set("teaching_class_id", String(input.teaching_class_id));
  }
  form.set("category", input.category);
  form.set("description", input.description);
  if (input.suggested_correction)
    form.set("suggested_correction", input.suggested_correction);
  form.set("captured_context", JSON.stringify(input.captured_context));
  if (input.screenshot) form.set("screenshot", input.screenshot, "aula.png");
  return form;
}

export default class LessonIssueReportsModule extends HttpFactory {
  async createReport(
    input: LessonIssueReportInput,
    signal?: AbortSignal,
  ): Promise<LessonIssueReportReceipt> {
    return await this.post(
      ENDPOINTS.CONTENT_QUALITY.REPORTS,
      buildLessonIssueReportForm(input),
      { signal },
    );
  }
}
